import { createFileRoute } from '@tanstack/react-router';

import StoreReviewsPage from '@/components/store/reviews/Page';

export const Route = createFileRoute('/store/reviews')({
	component: StoreReviewsPage,
});
